import React, { useEffect, useState } from 'react'

import { formatNumber } from '@js/common/utils'

import FormSlider from '@f/elements/FormSlider'

const FilterSlider = props => {
  let currentExpansionStage = props.isPrice
    ? {
        name: 'price__range',
        value: ','
      }
    : undefined

  for (const name in props.params) {
    if (props.isPrice && name.indexOf('price') > -1) {
      currentExpansionStage = {
        name,
        value: props.params[name]
      }
    }
  }

  const defaultConfig = {
    ...props.filter.values
  }

  const calculateMinMax = props => {
    return currentExpansionStage
      ? {
          min: props.filters[currentExpansionStage.name]
            ? props.filters[currentExpansionStage.name].split(',')[0]
              ? parseFloat(
                  props.filters[currentExpansionStage.name].split(',')[0]
                )
              : defaultConfig.min
            : defaultConfig.min,
          max: props.filters[currentExpansionStage.name]
            ? props.filters[currentExpansionStage.name].split(',')[1]
              ? parseFloat(
                  props.filters[currentExpansionStage.name].split(',')[1]
                )
              : defaultConfig.max
            : defaultConfig.max
        }
      : {
          min: props.filters[`${props.filter.name}__range`]
            ? props.filters[`${props.filter.name}__range`].split(',')[0]
              ? parseFloat(
                  props.filters[`${props.filter.name}__range`].split(',')[0]
                )
              : defaultConfig.min
            : defaultConfig.min,
          max: props.filters[`${props.filter.name}__range`]
            ? props.filters[`${props.filter.name}__range`].split(',')[1]
              ? parseFloat(
                  props.filters[`${props.filter.name}__range`].split(',')[1]
                )
              : defaultConfig.max
            : defaultConfig.max
        }
  }

  const [minMax, setMinMax] = useState(calculateMinMax(props))

  useEffect(() => {
    if (props.isPrice) {
      currentExpansionStage = {
        name: `${props.filter.default}__range`,
        value: ','
      }

      defaultConfig['slots'] = { ...props.filter.values.slots }

      for (let name in props.params) {
        if (props.isPrice && name.indexOf('price') > -1) {
          currentExpansionStage = {
            name,
            value: props.params[name]
          }
        }
      }
    }

    setMinMax(calculateMinMax(props))
  }, [props])

  const handleSliderMove = ([min, max]) => {
    setMinMax({ min, max })
  }

  const handleSliderDrop = ([min, max]) => {
    const currentParam = props.filter.name
    let params = { ...props.params }

    if (min === defaultConfig.min && max === defaultConfig.max) {
      if (props.isPrice) {
        delete params[currentExpansionStage.name]
      } else {
        delete params[`${currentParam}__range`]
      }
    } else {
      let newMin = min === defaultConfig.min ? '' : min
      let newMax = max === defaultConfig.max ? '' : max

      if (props.isPrice) {
        params[currentExpansionStage.name] = `${newMin},${newMax}`
      } else {
        params[`${currentParam}__range`] = `${newMin},${newMax}`
      }
    }

    props.updateParams(params)
  }

  const bars = props.isPrice && [
    ...defaultConfig.slots[currentExpansionStage.name.split('__')[0]]
  ]
  const barsMaxValue =
    bars && bars.reduce((prev, next) => Math.max(prev, next.doc_count), 0)

  let priceBars = bars && (
    <div className='SearchResultsFilters-price-bars'>
      {bars.map((bar, index) => {
        let barClassName = 'SearchResultsFilters-price-bar'
        if (bar.key >= minMax.min && bar.key <= minMax.max) {
          barClassName += ' is-active'
        }
        return (
          <div
            className={barClassName}
            key={`price_bar_${index}`}
            style={{ height: (bar.doc_count * 100) / barsMaxValue + '%' }}
          />
        )
      })}
    </div>
  )

  let suffix = props.filter.suffix || ''
  let labelSuffix = props.filter.labelSuffix || ''

  return (
    <>
      <div className='[ f-t-body f-c-fo-pri f-m-b-010 ]'>
        {`${formatNumber(minMax.min, minMax.min % 1 != 0 ? 1 : 0, ',', '.')}
            -
            ${defaultConfig.max === minMax.max ? '> ' : ''}${formatNumber(
          minMax.max,
          minMax.max % 1 != 0 ? 1 : 0,
          ',',
          '.'
        )} ${suffix} ${labelSuffix}`}
      </div>
      {priceBars}
      <FormSlider
        type='Range'
        value={[
          minMax.min || defaultConfig.min,
          minMax.max || defaultConfig.max
        ]}
        sliderMin={defaultConfig.min}
        sliderMax={defaultConfig.max}
        sliderStep={defaultConfig.steps}
        onChange={handleSliderMove}
        onAfterChange={handleSliderDrop}
      />
    </>
  )
}

export default FilterSlider
